import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AlertService, CampaignService} from '../_services';
import {Observable, of as observableOf} from 'rxjs';

@Injectable()
export class CampaignGuard implements CanActivate {
  constructor(
    protected router: Router,
    protected campaignService: CampaignService,
    protected alertService: AlertService
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const cachedCampaign = this.campaignService.getCurrentCampaign();

    if (cachedCampaign === null) {
      this.alertService.error('Campaign is not selected!', true);
      this.router.navigate(['/'], {replaceUrl: true});
      return observableOf(false);
    }

    return observableOf(true);
  }
}
